import { render } from "./DialogMenu.vue?vue&type=template&id=6a590834"
import script from "./DialogMenu.vue?vue&type=script&lang=js"
export * from "./DialogMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__